import { ErrorMsg } from '@/types/common';
import cn from 'classnames';
import { FieldError } from 'react-hook-form';

interface ErrorMessageProps {
    error: ErrorMsg | FieldError | undefined;
    // error: FieldError | undefined;
    className?: string;
    isPadded?: boolean;
}

const ErrorMessage = ({ error, className, isPadded = true }: ErrorMessageProps) => {
    return error && error?.message ? (
        <>
            {isPadded ? (
                <div className="flex justify-end">
                    <div className={cn('text-brand-red italic text-sm pt-1 w-full', className)}>{error?.message}</div>
                </div>
            ) : (
                <div className={cn('text-brand-red italic text-sm pt-1 w-full', className)}>{error?.message}</div>
            )}
        </>
    ) : null;
};

export default ErrorMessage;
